export const category_from_role = {
    account_management: "account-management",
    content_team: "content",
    creative_media_team: "creative",
    culture_team: "culture",
    developers: "developers",
    finance_team: "finance",
    interns: "interns",
    onboarding_team: "onboarding",
    operations: "operations",
    paid_ads_team: "paid-ads",
    partner_team: "partner",
    sales_team: "sales",
    seo_team: "seo",
    social_team: "social",
    web_team: "web"
};

export async function fetchCurrentUser() {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('No auth token');
    const res = await safeFetch(`/wp-json/wp/v2/users/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error('Failed to fetch user');
    return res.json();
}

export async function fetchCategoriesBySlugs(slugs) {
    const res = await safeFetch(`/wp-json/wp/v2/categories?slug=${slugs.join(',')}`, {
        method: 'GET'
    });
    if (!res.ok) throw new Error('Failed to fetch categories');
    return res.json();
}

export async function fetchPostsByCategoryIds(catIds, extra = '') {
    const res = await safeFetch(`/wp-json/wp/v2/posts?categories=${catIds.join(',')}${extra}`, {
        method: 'GET'
    });
    if (!res.ok) throw new Error('Failed to fetch posts');
    return res.json();
}

export async function fetchAnnouncements(extra = '') {
    const res = await safeFetch(`/wp-json/wp/v2/announcement?${extra.replace(/^&/, '')}`, {
        method: 'GET'
    });
    if (!res.ok) throw new Error('Failed to fetch announcements');
    return res.json();
}

export async function safeFetch(url, options = {}) {
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response;
    } catch (error) {
        console.error("Fetch failed:", error);
        // Fallback to VUE_APP_URL if the fetch fails with a root relative URL
        const fallbackUrl = new URL(url, process.env.VUE_APP_URL).href;
        try {
            const response = await fetch(fallbackUrl, options);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response;
        } catch (fallbackError) {
            console.error("Fallback fetch failed:", fallbackError);
            throw fallbackError;
        }
    }
}

export async function fetchPosts(query = '', postTypes = ['post']) {
  try {
    const promises = postTypes.map(type => {
      const endpoint = type === 'post' ? 'posts' : type;
      return safeFetch(`/wp-json/wp/v2/${endpoint}?${query.replace(/^&/, '')}`)
        .then(res => {
          if (!res.ok) throw new Error(`Failed to fetch ${type}`);
          return res.json(); // Return the JSON object directly
        });
    });
    
    const results = await Promise.all(promises);
    
    // Check if the fetched data is an array before combining and sorting
    let postsArray = [];
    for (const result of results) {
      if (Array.isArray(result)) {
        postsArray = postsArray.concat(result);
      } else {
        throw new Error('Unexpected API response structure: expected an array of posts');
      }
    }
    
    // Combine all post types and sort by date (newest first)
    return postsArray.sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
}